import { BASE_URL, WORKSHOP_EVALUATION_QUESTION_OPTION } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopEvaluationQuestionOptionInput } from "models/workshopEvaluationQuestionOption";


export async function getWorkshopEvaluationQuestionOptions(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_EVALUATION_QUESTION_OPTION + params);
  return response.data;
}
export async function addWorkshopEvaluationQuestionOption(data: IWorkshopEvaluationQuestionOptionInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_EVALUATION_QUESTION_OPTION, data);
  return response.data;
}
export async function editWorkshopEvaluationQuestionOption(data: IWorkshopEvaluationQuestionOptionInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_EVALUATION_QUESTION_OPTION + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopEvaluationQuestionOption(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_EVALUATION_QUESTION_OPTION + "/" + id);
  return response.data;
}

export const WorkshopEvaluationQuestionOptionCells: HeadCell[] = [

  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "T_description",
  },
  {
    id: "descriptionAr",
    numeric: false,
    disablePadding: false,
    label: "T_description_ar",
  },
  {
    id: "score",
    numeric: true,
    disablePadding: false,
    label: "T_score",
  },
  {
    id: "optionOrder",
    numeric: true,
    disablePadding: false,
    label: "T_order",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
